import*as actionTypes from'../actions/actionTypes';/*
TYPES:
  info = 0,
  error = 1,
  blocked = 2,
  severeWarning = 3,
  success = 4,
  warning = 5
*/var initialState={message:"",type:1,timeout:4000};var reducer=function reducer(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];// must return the same state or an updated version.
// example switch case to determine action. use immutable patterns for updating state.
switch(action.type){case actionTypes.SET_NOTIFICATION:return Object.assign({},state,action.data);case actionTypes.CLEAR_NOTIFICATION:return initialState;default:return Object.assign({},state);}};export default reducer;


//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/notifications.js
// module id = 1874
// module chunks = 29